// utils/cascaderHelper.js
export function transformSpecData(data, firstCategoryId) {
    if (!Array.isArray(data)) return []
    return data.map(group => {
        // 一级节点：value 使用 itemCode，label 使用 name
        const node = {
            value: group.id,           // 级联组件选中的值
            // label: group.name,               // 显示文本
            label: firstCategoryId == '2' ? group.name : group.itemCode,               // 显示文本20260527
            original: group,                 // 保留原始数据（含 id, itemCode, name 等）
        }
        // 处理子节点（规格值列表）
        if (group.productCodeDTOList && group.productCodeDTOList.length) {
            node.children = group.productCodeDTOList.map(item => ({
                value: item.id,       // 二级 value 使用 productCode
                label: item.productCode,       // 二级 label 使用 productCode（也可显示其他）
                original: item,                // 保留原始数据（含 id, productCode）
            }))
        }
        return node
    })
}